export default __webpack_public_path__ + "static/media/pictogramBeaconCash40.970742a5.svg";